export const getAccessToken = (): string | null => {
    return localStorage.getItem("accessToken");
  };
  
  export const setAccessToken = (token: string): void => {
    localStorage.setItem("accessToken", token);
  };
  
  export const setRefreshToken = (token: string): void => {
    localStorage.setItem("refreshToken", token);
  };
  
  export const clearTokens = (): void => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  };
  
  export const getRefreshToken = () => {
    return localStorage.getItem("refreshToken");
  }